import { render, staticRenderFns } from "./PlayerAvatarMedia.vue?vue&type=template&id=75d485a1"
import script from "./PlayerAvatarMedia.vue?vue&type=script&lang=js"
export * from "./PlayerAvatarMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports